import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import aboutme from "../../Assets/aboutme.png";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import dev from "../../Assets/dev.svg";
import uiux from "../../Assets/uiux.svg";
import pm from "../../Assets/pm.svg";
import { AiOutlineCheck  } from "react-icons/ai";


function Home2() {
  const skillsData = [
    {
      title: "Software Development",
      skills: ["Next.js","Angular.js", "MERN", "WordPress", "WooCommerce", "JavaScript", "TypeScript"],
      image: dev,
      color: "bg-purple-900",
    },
    {
      title: "UI/UX Design",
      skills: ["Wireframing", "Prototyping", "User Research", "User Feedback","Responsive Design", "Information Architecture" ],
      image: uiux,
      color: "bg-purple-900",
    },
    {
      title: "Product Management",
      skills: ["Market Research", "Product Roadmap", "User Analytics", "Feature Prioritization", "Technical Documentation", "Product Lifecycle Management"],
      image: pm,
      color: "bg-purple-900",
    },
  ];

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="home-about-description text-center">
            <h1 style={{ fontSize: "2.6em" }}>
              Why Hire <span className="purple"> Me ?</span>
            </h1>
          </Col>
        </Row>

      {/* Skills Section - Three Equal Columns */}
<Row className="mt-4 text-white text-center">
  {skillsData.map((item, index) => (
    <Col key={index} md={4} className="d-flex align-items-stretch mb-5">
      <div className={`w-100 h-100 rounded shadow-xl p-4 border border-white-100  ${item.color}`}>
        <img src={item.image} alt={item.title} className="w-75 mb-3" />  {/* Increased Image Size */}
        <h2 className="fs-5 fw-bold wavy-underline">{item.title}</h2>
        <ul className="list-unstyled mt-3">
       
          {item.skills.map((skill, i) => (
             <li key={i}>  <AiOutlineCheck /> {skill}</li>
          ))}
        </ul>
      </div>
    </Col>
  ))}
</Row>


        {/* Avatar Image */}
        <Row className="justify-content-center mt-4">
          <Col md={4} className="d-flex align-items-center justify-content-center">
            <img src={aboutme} className="img-fluid" alt="avatar" />
          </Col>
        </Row>

        {/* Social Links */}
        <Row>
          <Col md={12} className="home-about-social text-center mt-4">
            <h1> Socials </h1>
            <p>Feel free to <span className="purple">connect </span>with me</p>
            <ul className="home-about-social-links d-flex justify-content-center list-unstyled">
              <li className="social-icons mx-2">
                <a
                  href="https://github.com/koustavmoitra"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub size={30} />
                </a>
              </li>
              <li className="social-icons mx-2">
                <a
                  href="https://www.linkedin.com/in/koustav-moitra/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn size={30} />
                </a>
              </li>
              <li className="social-icons mx-2">
                <a
                  href="https://www.instagram.com/koustavmoitra12321/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram size={30} />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
